import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../js/stores/language.js';
import googleMaps from '../../js/controllers/google-map-lib.js';
var GoogleMapItem = function GoogleMapItem(props, _ref) {
  var $f7 = _ref.$f7,
    $h = _ref.$h,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var useLocations = 0;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          setTimeout(function () {
            extraSetup();
          }, 250);
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var onPopUpClose = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(useLocations && document.getElementById("".concat(props.selector, "-pac-input")).value.length > 0)) {
              _context2.next = 1;
              break;
            }
            _context2.next = 1;
            return $f7.emit('updatePlacesList');
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onPopUpClose() {
      return _ref3.apply(this, arguments);
    };
  }();
  var extraSetup = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            useLocations = props.useLocations !== undefined && props.useLocations === "1" ? 1 : 0;
            _context3.next = 1;
            return googleMaps.initSearchBox("".concat(props.selector), useLocations);
          case 1:
            $update();
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function extraSetup() {
      return _ref4.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="popup ${props.selector}-popup" @popup:close=${onPopUpClose}>
  <div class="page">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="title">${locale.translate('googleMap.dialog.title')}</div>
        <div class="right">
          <a class="link popup-close">
            <i class="icon material-symbols-outlined color-blue">cancel</i>
          </a>
        </div>
      </div>
    </div>
    <div class="page-content">
      <div id="${props.selector}-pac-card" class="pac-card">
        <div>
          <div id="${props.selector}-title-id">${locale.translate('googleMap.dialog.inputTitle')}</div>
        </div>
        <div id="${props.selector}-pac-container">
          <input id="${props.selector}-pac-input" class="pac-input" type="text" placeholder="${locale.translate('googleMap.dialog.inputPlaceHolder')}" />
        </div>
      </div>
      <div id="${props.selector}-map"></div>
      <div id="${props.selector}-info-window-content">
        <span id="${props.selector}-place-name-on-map" class="title-id"></span><br />
        <span id="${props.selector}-place-address-on-map"></span>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
};
//Export component name
export default GoogleMapItem;